import React from 'react';
import {Bar} from 'react-chartjs-2';
import './Chart.css'
import FontIcon from 'material-ui/FontIcon';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'

const options = {
    responsive: true,
    maintainAspectRatio: false,

    legend: {
        display: true,
        position: 'bottom',
        labels: {boxWidth: 15, padding: 20}
    },
    tooltips: {
        mode: 'label'
    },
    elements: {
        line: {
            fill: false,
            borderWidth: 2,
        }
    },
    scales: {
        xAxes: [
            {
                barThickness: 6,
                // barPercentage: 1.0,
                categoryPercentage: 0.5,
                display: true,
                gridLines: {
                    display: false
                },
            }
        ],
        yAxes: [
            {
                type: 'linear',
                display: true,

                position: 'left',
                id: 'y-axis-1',
                gridLines: {
                    display: true
                },
                ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        if(parseInt(value, 10) >= 1000){
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        } else {
                            return value;
                        }
                    }
                }
            },
        ]
    }
};

const getCurrencies = (data) => {

    let currencies = [];
    for (let currency in data) {
        currencies.push(currency)
    }
    return currencies;
};

const slice = (arr) => {
    var start = 0;
    return arr.slice(start, arr.length)
};

export const ChartTransactionDay = ({data, strings, currency}) => {
    let currencies = getCurrencies(data);
    let chartData = null;
    const dataPerCurrency = currencies.reduce(
        (perCurrency, cur) => ({
            ...perCurrency,
            [cur]: data[cur].reduce((acc, val) => {
                return {
                    labels: [...acc.labels, val.hour],
                    salesInP: [...acc.salesInP, val.salesInProcessedAmount/100],
                    salesInU: [...acc.salesInU, val.salesInUnprocessedAmount/100],
                    salesO:  [...acc.salesO, val.salesOut/100]
                };
            }, {
                labels: [],
                salesInP: [],
                salesInU: [],
                salesO: []
            })
        }), {}
    )

    if (currencies.length > 0) {
        chartData = {
            labels: slice(dataPerCurrency[currency].labels),
            datasets: [
                {
                    type: 'bar',
                    label: strings.ProcessedSales,
                    data: slice(dataPerCurrency[currency].salesInP),
                    fill: false,
                    backgroundColor: LoomisColors.darkGrey,
                    borderColor: LoomisColors.darkGrey,
                    hoverBackgroundColor: LoomisColors.darkGrey,
                    hoverBorderColor: LoomisColors.darkGrey,
                    borderWidth: 0,
                    yAxisID: 'y-axis-1',

                },
                {
                    type: 'bar',
                    label: strings.UnprocessedSales,
                    data: slice(dataPerCurrency[currency].salesInU),
                    fill: false,
                    backgroundColor: LoomisColors.grey,
                    borderColor: LoomisColors.grey,
                    hoverBackgroundColor: LoomisColors.grey,
                    hoverBorderColor: LoomisColors.grey,
                    borderWidth: 0,
                    yAxisID: 'y-axis-1',

                },
                {
                    type: 'bar',
                    label: strings.SalesOut,
                    data: slice(dataPerCurrency[currency].salesO),
                    fill: false,
                    backgroundColor: LoomisColors.black,
                    borderColor: LoomisColors.black,
                    hoverBackgroundColor: LoomisColors.black,
                    hoverBorderColor: LoomisColors.black,
                    borderWidth: 0,
                    yAxisID: 'y-axis-1',

                }
            ]
        }
    }

    return (
        <div className="ChartWrapper">
            <div className="ChartHeader">
                <FontIcon className="material-icons">equalizer</FontIcon>
                <div>{strings.SalesPerHour} : {currency}</div>
            </div>
            <div className="Chart">
                {chartData !== null ? (
                    <Bar data={chartData} options={options}/>
                ) : strings.NoDataAvailable}
            </div>
        </div>
    );
};

export default translate('ChartTransactionDay')(ChartTransactionDay);



// WEBPACK FOOTER //
// ./src/components/chart/ChartTransactionDay.js